import { PlayerVideosData } from '@/types/players.types';

export const isValidYoutubeVideo = (url: string): boolean => {
  return url !== '' && url.includes('youtube');
};

export const getYouTubeVideoData = (
  url: string
): {
  videoId: string;
  start?: number;
} => {
  if (!url) return { videoId: '' };

  let videoId = '';
  let start: number | undefined;

  // Extract ID
  if (url.includes('watch?v=')) {
    videoId = url.split('watch?v=')[1]?.split(/[?&]/)[0] ?? '';
  } else if (url.includes('/live/')) {
    videoId = url.split('/live/')[1]?.split(/[?&]/)[0] ?? '';
  }

  // Extract timestamp (?t= or &t=)
  const tMatch = url.match(/[?&]t=(\d+)/);
  if (tMatch) {
    start = Number(tMatch[1]);
  }

  return { videoId, start };
};

export const generateMatchTitle = (video: PlayerVideosData): string => {
  const teamOne = `${video.teamOnePlayerOneLastName}${video.teamOnePlayerOneNameSuffix}${
    video.teamOnePlayerTwoLastName
      ? `/${video.teamOnePlayerTwoLastName}${video.teamOnePlayerTwoNameSuffix}`
      : ''
  }`;

  const teamTwo = `${video.teamTwoPlayerOneLastName}${video.teamTwoPlayerOneNameSuffix}${
    video.teamTwoPlayerTwoLastName
      ? `/${video.teamTwoPlayerTwoLastName}${video.teamTwoPlayerTwoNameSuffix}`
      : ''
  }`;

  return `${teamOne} v ${teamTwo}`;
};
